import { uri } from "../constants";
import axios from "axios";

// Get all posts with filters and pagination
export async function getAllPosts(params = {}) {
  const queryParams = new URLSearchParams(params).toString();
  const response = await axios.get(`${uri}/posts?${queryParams}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
}

// Get posts by user
export async function getPostsByUser(userId, params = {}) {
  const queryParams = new URLSearchParams(params).toString();
  const response = await axios.get(
    `${uri}/posts/user/${userId}?${queryParams}`,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
}

// Get specific post by ID or slug
export async function getPost(identifier) {
  const response = await axios.get(`${uri}/posts/${identifier}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
}

// Create a new post
export async function createPost(userId, postData) {
  const response = await axios.post(`${uri}/posts/user/${userId}`, postData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
}

// Update an existing post
export async function updatePost(postId, postData) {
  const response = await axios.put(`${uri}/posts/${postId}`, postData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
}

// Delete a post
export async function deletePost(postId) {
  const response = await axios.delete(`${uri}/posts/${postId}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
}

// Track post view
export async function trackPostView(postId, viewData = {}) {
  const response = await axios.post(`${uri}/posts/${postId}/view`, viewData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
}

// Toggle post like
export async function togglePostLike(postId, userId) {
  const response = await axios.post(
    `${uri}/posts/${postId}/like/${userId}`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
}

// Get post analytics
export async function getPostAnalytics(postId) {
  const response = await axios.get(`${uri}/posts/${postId}/analytics`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
}

// Bulk create posts
export async function bulkCreatePosts(postsArray) {
  const response = await axios.post(`${uri}/posts/bulk`, postsArray, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
}
